export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/rekomendasi/:token',
    name: 'auth-rekomendasi',
    component: () => import('@/views/pages/authentication/Login-rekomendasi.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pewawancara/:token',
    name: 'auth-pewawancara',
    component: () => import('@/views/pages/authentication/Login-pewawancara.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/verifikasi/:email',
    name: 'auth-verifikasi',
    component: () => import('@/views/pages/authentication/Verifikasi-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/pengumuman',
    name: 'pengumuman',
    component: () => import('@/views/pages/pengumuman/List.vue'),
  },
  {
    path: '/pages/pengumuman/detail',
    name: 'pengumuman-detail',
    component: () => import('@/views/pages/pengumuman/Detail.vue'),
  },
  {
    path: '/lembar-kehidupan',
    name: 'lembar-kehidupan',
    component: () => import('@/views/pages/lembar-kehidupan/FormWizard.vue')
  },
  {
    path: '/rekomendasi',
    name: 'rekomendasi',
    component: () => import('@/views/pages/rekomendasi/Form.vue')
  },
  {
    path: '/assessment',
    name: 'assessment',
    component: () => import('@/views/pages/assessment/FormWizard.vue')
  },
  {
    path: '/kompetensi-dasar',
    name: 'kompetensi',
    component: () => import('@/views/pages/kompetensi-dasar/Form.vue')
  },
  {
    path: '/kompetensi-analisa-kasus',
    name: 'kompetensi-analisa-kasus',
    component: () => import('@/views/pages/kompetensi-dasar/AnalisaKasusForm.vue')
  },
  {
    path: '/kompetensi-dasar/test/:token_ujian',
    name: 'kompetensi-dasar-test',
    component: () => import('@/views/pages/kompetensi-dasar/Test.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/cek-wizard',
    name: 'cek-wizard',
    component: () => import('@/views/forms/form-wizard/FormWizard.vue')
  },
  // {
  //   path: '/pages/authentication/login-v1',
  //   name: 'auth-login-v1',
  //   component: () => import('@/views/pages/authentication/Login-v1.vue'),
  //   meta: {
  //     layout: 'full',
  //   },
  // },
  // {
  //   path: '/pages/authentication/login-v2',
  //   name: 'auth-login-v2',
  //   component: () => import('@/views/pages/authentication/Login-v2.vue'),
  //   meta: {
  //     layout: 'full',
  //   },
  // },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },

  {
    path: '/contoh',
    name: 'contoh',
    component: () => import('@/views/components/breadcrumb/Breadcrumb.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  // {
  //   path: '/pages/authentication/register-v1',
  //   name: 'auth-register-v1',
  //   component: () => import('@/views/pages/authentication/Register-v1.vue'),
  //   meta: {
  //     layout: 'full',
  //   },
  // },
  // {
  //   path: '/pages/authentication/register-v2',
  //   name: 'auth-register-v2',
  //   component: () => import('@/views/pages/authentication/Register-v2.vue'),
  //   meta: {
  //     layout: 'full',
  //   },
  // },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  // {
  //   path: '/pages/authentication/forgot-password-v1',
  //   name: 'auth-forgot-password-v1',
  //   component: () => import('@/views/pages/authentication/ForgotPassword-v1.vue'),
  //   meta: {
  //     layout: 'full',
  //   },
  // },
  // {
  //   path: '/pages/authentication/forgot-password-v2',
  //   name: 'auth-forgot-password-v2',
  //   component: () => import('@/views/pages/authentication/ForgotPassword-v2.vue'),
  //   meta: {
  //     layout: 'full',
  //     resource: 'Auth',
  //   },
  // },
  {
    path: '/reset-password/:token',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  // {
  //   path: '/pages/authentication/reset-password-v2',
  //   name: 'auth-reset-password-v2',
  //   component: () => import('@/views/pages/authentication/ResetPassword-v2.vue'),
  //   meta: {
  //     layout: 'full',
  //     redirectIfLoggedIn: true,
  //   },
  // },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Pengaturan Akun',
      breadcrumb: [
        {
          text: 'Pengaturan Akun',
          active: true,
        },
      ],
      resource: 'account-setting',
      action: 'manage',
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },

  {
    path: '/pages/faq',
    name: 'pages-faq',
    component: () => import('@/views/pages/faq/Faq.vue'),
    meta: {
      pageTitle: 'FAQ',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base',
    name: 'pages-knowledge-base',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBase.vue'),
    meta: {
      pageTitle: 'Knowledge Base',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base/:category',
    name: 'pages-knowledge-base-category',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategory.vue'),
    meta: {
      pageTitle: 'Category',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/knowledge-base/:category/:slug',
    name: 'pages-knowledge-base-question',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategoryQuestion.vue'),
    meta: {
      pageTitle: 'Question',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          to: '/pages/Knowledge-base/category',
        },
        {
          text: 'Question',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/pricing',
    name: 'pages-pricing',
    component: () => import('@/views/pages/pricing/Pricing.vue'),
  },
  {
    path: '/pages/blog/list',
    name: 'pages-blog-list',
    component: () => import('@/views/pages/blog/BlogList.vue'),
    meta: {
      pageTitle: 'Blog List',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/:id',
    name: 'pages-blog-detail',
    component: () => import('@/views/pages/blog/BlogDetail.vue'),
    meta: {
      pageTitle: 'Blog Detail',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/edit/:id',
    name: 'pages-blog-edit',
    component: () => import('@/views/pages/blog/BlogEdit.vue'),
    meta: {
      pageTitle: 'Blog Edit',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
